import { Injectable, signal } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { Booking } from '../../../../../../models/orderModel';
import { BehaviorSubject } from 'rxjs';
import { subHours } from 'date-fns';
import { BookingPriceService } from '../../../../../services/booking-price.service';
import { BookingConfigService } from '../../../../../services/booking-config.service';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  // Custom validator for Quality hotel booking number format
  // static qualityXpoBookingNumberValidator(control: AbstractControl): ValidationErrors | null {
  //   if (!control.value) {
  //     return null;
  //   }

  //   const pattern = /^SE007S\d{7}$/;
  //   if (!pattern.test(control.value)) {
  //     return { qualityXpoBookingNumber: true };
  //   }

  //   return null;
  // }

  private _form: any;
  private _organizationId: string;
  private _discountCode: string = '';
  private _availableParkings: any;
  private _selectedParking: any;
  private _selectedArrivalFlight: any;
  private _selectedDepartureFlight = new BehaviorSubject<any>(null);
  private _searchStartDate: any;
  private _searchEndDate: any;
  private _departureFlightList: any;
  private _arrivalFlightList: any;
  private _paymentReference: any;
  private _paymentReferenceSource = new BehaviorSubject<any>(null);
  public _toThePayment = new BehaviorSubject<any>(null);
  public _isPaymentCompleted = new BehaviorSubject<any>(null);
  private _updatedDepartureFlight = new BehaviorSubject<any>(null);
  private _organization: any;
  private _departurePickUp: any;
  private _arrivalPickup: any;
  private _isArrivalByFlight: any;
  private _arrivalHotel: any;
  private _departureHotel: any;
  private _departureTerminal: any;
  private _arrivalTerminal: any;
  private _isDepartureHotel: any;

  public enforceMandatoryProduct = signal(false);
  public mandatoryServices = signal<FormGroup[]>([]);
  private site: any;
  private config: any;

  constructor(
    private fb: FormBuilder,
    private pricingService: BookingPriceService,
    private bookingConfigService: BookingConfigService
  ) {
    const configs = this.bookingConfigService.setOrganizationFromUrl();
    let config = this.bookingConfigService.getConfig();
    this.config = config;
    this._organizationId = config.orgId;
    this.site = config.site;
    this.initForm(this.site);

    this._form.get('parking').valueChanges.subscribe((change: any) => {
      let selectedServices = this.getSelectedServices();
      let selectedParking = change.selectedParking;
      this.pricingService.calculateTotal(selectedParking, selectedServices);
    });

    this._form.get('parking.additionalServices').valueChanges.subscribe((change: any) => {
      this.mandatoryServices.set(this.getMandatoryServices());
      this.enforceMandatoryProduct.set(this.determineIfEnforceMandatoryProduct(this.getSelectedServices()));
    });

  }

  get discountCode() {
    if (this._discountCode && typeof this._discountCode === 'string' && (this._discountCode.toUpperCase() === 'NONE' || this._discountCode === 'null')) {
      return '';
    }
    return this._discountCode || '';
  }

  set discountCode(value: any) {
    if (value && typeof value === 'string' && (value.toUpperCase() === 'NONE' || value === 'null')) {
      this._discountCode = '';
    } else {
      this._discountCode = value || '';
    }
  }

  get organization() {
    return this._organization;
  }

  public set organization(value: any) {
    this._organization = value;
  }

  get departureHotel() {
    return this._departureHotel
  }
  get arrivalHotel() {
    return this._arrivalHotel
  }

  public set arrivalHotel(hotel: any) {
    this._arrivalHotel = hotel;
  }
  public set departureHotel(hotel: any) {
    this._departureHotel = hotel;
  }

  get searchStartDate(): any {
    return this._searchStartDate;
  }

  get searchEndDate(): any {
    return this._searchEndDate;
  }

  public set searchStartDate(val: any) {
    this._searchStartDate = val;
  }

  public set searchEndDate(val: any) {
    this._searchEndDate = val;
  }

  get isArrivalByFlight(): any {
    return this._isArrivalByFlight;
  }

  set isArrivalByFlight(val: any) {
    this._isArrivalByFlight = val;
  }

  get arrivalPickup(): any {
    return this._arrivalPickup;
  }

  get departurePickup(): any {
    return this._departurePickUp;
  }

  set arrivalPickup(val: any) {
    this._arrivalPickup = val;
  }

  set departurePickup(val: any) {
    this._departurePickUp = val;
  }

  get departureTerminal(): any {
    return this._departureTerminal;
  }

  get arrivalTerminal(): any {
    return this._arrivalTerminal;
  }

  set departureTerminal(val: any) {
    this._departureTerminal = val;
  }

  set arrivalTerminal(val: any) {
    this._arrivalTerminal = val;
  }

  get isDepartureHotel(): any {
    return this._isDepartureHotel;
  }

  set isDepartureHotel(val: any) {
    this._isDepartureHotel = val;
  }

  public paymentReference$ = this._paymentReferenceSource.asObservable();
  set paymentReference(val: any) {
    this._paymentReference = val;
    this._paymentReferenceSource.next(val);
  }

  get paymentReference() {
    return this._paymentReference;
  }

  getForm() {
    return this._form;
  }

  initForm(site: string) {
    this._selectedParking = null;
    if (site === 'skavsta') {
      this._form = this.fb.group({
        details: this.fb.group({
          regNr: ['', { validators: [Validators.required, Validators.minLength(4), Validators.maxLength(9), Validators.pattern('^[A-Z0-9]{4,9}$')] }],
          firstname: ['', { validators: Validators.required }],
          lastname: ['', { validators: Validators.required }],
          email: ['', { validators: [Validators.email, Validators.required] }],
          cellular: ['', { validators: Validators.required }],
          persons: ['', { validators: Validators.required }],
          consent: [true, Validators.requiredTrue],
          parkingspacesize: [false, Validators.requiredTrue],
        }),
        parkingGroup: this.fb.group({
          departureDate: ['', Validators.required],
          departureFlight: ['', Validators.required],
          arrivalDate: ['', Validators.required],
          arrivalFlight: ['', Validators.required]
        }),
        search: this.fb.group({
          arrivalDatetime: ['', Validators.required],
          departureDatetime: ['', Validators.required],
        }),
        parking: this.fb.group({
          selectedParking: [''],
          additionalServices: this.fb.array([])
        })

      });

    }
    else if (site?.toLocaleLowerCase() === 'flygets' || site?.toLocaleLowerCase() === 'nazar' || site?.toLocaleLowerCase() === 'tui') {
      this._form = this.fb.group({
        details: this.fb.group({
          regNr: ['', { validators: [Validators.required, Validators.minLength(4), Validators.maxLength(9), Validators.pattern('^[A-Z0-9]{4,9}$')] }],
          firstname: ['', { validators: Validators.required }],
          lastname: ['', { validators: Validators.required }],
          email: ['', { validators: [Validators.email, Validators.required] }],
          cellular: ['', { validators: Validators.required }],
          persons: ['', { validators: Validators.required }],
          onlyHandBaggage: ['', { validators: Validators.required }],
          comment: [''],
          consent: [true, Validators.requiredTrue],
          parkingspacesize: [false, Validators.requiredTrue],
          // arrivalTimeAtParking: ['', Validators.required]
        }),
        search: this.fb.group({
          isArrivalHotel: [false],
          isDepartureHotel: [false],
          arrivalDatetime: ['', Validators.required],
          departureDatetime: ['', Validators.required],
          arrivalFlightDate: [''],
          departureFlightDate: [''],

        }),
        flights: this.fb.group({
          arrivalFlight: ['', Validators.required],
          departureFlight: ['', Validators.required]
        }),
        hotels: this.fb.group({
          arrivalHotel: ['', Validators.required],
          departureHotel: ['', Validators.required],
          departureDatetime: ['', Validators.required],
          arrivalDatetime: ['', Validators.required]
        }),
        parkingGroup: this.fb.group({
          departureDate: ['', Validators.required],
          departureFlight: ['', Validators.required],
          arrivalDate: ['', Validators.required],
          arrivalFlight: ['', Validators.required]
        }),
        parking: this.fb.group({
          selectedParking: [''],
          additionalServices: this.fb.array([])

        })

      });
    }

    else if (site === 'mdpark') {
      this._form = this.fb.group({
        details: this.fb.group({
          regNr: ['', { validators: [Validators.required, Validators.minLength(4), Validators.maxLength(9), Validators.pattern('^[A-Z0-9]{4,9}$')] }],
          firstname: ['', { validators: Validators.required }],
          lastname: ['', { validators: Validators.required }],
          email: ['', { validators: [Validators.email, Validators.required] }],
          cellular: ['', { validators: Validators.required }],
          persons: ['', { validators: Validators.required }],
          onlyHandBaggage: ['', { validators: Validators.required }],
          comment: [''],
          consent: [true, Validators.requiredTrue],
          parkingspacesize: [false, Validators.requiredTrue],
        }),
        search: this.fb.group({
          isArrivalHotel: [false],
          isDepartureHotel: [false],
          arrivalDatetime: ['', Validators.required],
          departureDatetime: ['', Validators.required],
          arrivalFlightDate: [''],
          departureFlightDate: [''],
        }),
        flights: this.fb.group({
          arrivalFlight: ['', Validators.required],
          departureFlight: ['', Validators.required]
        }),
        hotels: this.fb.group({
          arrivalHotel: ['', Validators.required],
          departureHotel: ['', Validators.required],
          departureDatetime: ['', Validators.required],
          arrivalDatetime: ['', Validators.required]
        }),
        parkingGroup: this.fb.group({
          departureDate: ['', Validators.required],
          departureFlight: ['', Validators.required],
          arrivalDate: ['', Validators.required],
          arrivalFlight: ['', Validators.required]
        }),
        parking: this.fb.group({
          selectedParking: [''],
          additionalServices: this.fb.array([])
        })

      });
    }

    else if (site === 'quality-xpo-arlanda' || site === 'aiden-short-term') {
      const detailsGroupConfig: any = {
        regNr: ['', { validators: [Validators.required, Validators.minLength(4), Validators.maxLength(9), Validators.pattern('^[A-Z0-9]{4,9}$')] }],
        firstname: ['', { validators: Validators.required }],
        lastname: ['', { validators: Validators.required }],
        email: ['', { validators: [Validators.email, Validators.required] }],
        cellular: ['', { validators: Validators.required }],
        persons: ['', { validators: Validators.required }],
        consent: [true, Validators.requiredTrue],
        parkingspacesize: [false, Validators.requiredTrue],
        hotelInfoConsent: [true, Validators.requiredTrue]
      };
      if (site === 'quality-xpo-arlanda') {
        detailsGroupConfig.bookingNumber = [''];
      }
      this._form = this.fb.group({
        details: this.fb.group(detailsGroupConfig),
        parkingGroup: this.fb.group({
          departureDate: ['', Validators.required],
          departureFlight: ['', Validators.required],
          arrivalDate: ['', Validators.required],
          arrivalFlight: ['', Validators.required]
        }),
        search: this.fb.group({
          arrivalDatetime: ['', Validators.required],
          departureDatetime: ['', Validators.required],
        }),
        parking: this.fb.group({
          selectedParking: [''],
          additionalServices: this.fb.array([])
        })
      });

    }

    else if (site === 'quality' || site === 'aiden') {
      const detailsGroupConfig: any = {
        regNr: ['', { validators: [Validators.required, Validators.minLength(4), Validators.maxLength(9), Validators.pattern('^[A-Z0-9]{4,9}$')] }],
        firstname: ['', { validators: Validators.required }],
        lastname: ['', { validators: Validators.required }],
        email: ['', { validators: [Validators.email, Validators.required] }],
        cellular: ['', { validators: Validators.required }],
        onlyHandBaggage: ['', { validators: Validators.required }],
        consent: [true, Validators.requiredTrue],
        parkingspacesize: [false, Validators.requiredTrue],
        hotelInfoConsent: [true, Validators.requiredTrue]
      };
      if (site === 'quality') {
        detailsGroupConfig.bookingNumber = ['', { validators: Validators.required }];
      }
      this._form = this.fb.group({
        details: this.fb.group(detailsGroupConfig),
        parkingGroup: this.fb.group({
          departureDate: ['', Validators.required],
          departureFlight: ['', Validators.required],
          arrivalDate: ['', Validators.required],
          arrivalFlight: ['', Validators.required]
        }),
        search: this.fb.group({
          isArrivalHotel: [true, Validators.required],
          isDepartureHotel: [false, Validators.required],
          isArrivalByFlight: [true, Validators.required],
          arrivalDatetime: ['', Validators.required],
          departureDatetime: ['', Validators.required],
          arrivalFlightDate: [''],
          departureFlightDate: ['']
        }),
        flights: this.fb.group({
          arrivalFlight: ['', Validators.required],
          departureFlight: ['', Validators.required]
        }),
        hotels: this.fb.group({
          departureFlightDate: [''],
          departureDatetime: [''],
          departureDatetimeForTransfer: [''],
          arrivalDate: ['', Validators.required],
          parkingStartDate: [''],
          parkingEndDatetime: ['', Validators.required],
        }),
        parking: this.fb.group({
          selectedParking: [''],
          additionalServices: this.fb.array([])
        }),
        pickup: this.fb.group({
          departurePassengers: 0,
          departureRoute: ['', Validators.required],
          arrivalRoute: ['', Validators.required],
          departurePickupTime: [''],
          arrivalPickupTime: ['']
        }),
        terminal: this.fb.group({
          arrivalTerminal: [''],
          departureTerminal: ['']
        })
      });
    }

  }

  updateFormArray(services: any): void {
    const additionalServices = this._form.get('parking.additionalServices');
    additionalServices.clear();

    services.forEach((service: any) => {
      const serviceGroup = this.fb.group({
        id: [service.id],
        name: [service.name],
        description: [service?.description],
        productId: [service?.productId],
        productCode: [service?.productCode],
        availability: [service?.availability],
        status: [service?.status],
        statusName: [service?.statusName],
        price: [service?.price],
        vat: [service?.vat],
        vatPercentage: [service?.vatPercentage],
        totalPrice: [service?.totalPrice],
        discountAmount: [service?.discountAmount],
        discountVatAmount: [service?.discountVatAmount],
        discountTotalPrice: [service?.discountTotalPrice],
        discountCheckPercent: [service?.discountCheckPercent],
        discountCheckAmount: [service?.discountCheckAmount],
        performingOrganizationName: [service?.performingOrganizationName],
        typeName: [service?.typeName],
        isSelected: [false],
      });
      additionalServices.push(serviceGroup);
    });

  }

  //additional services functions--should be moved to separate service
  determineIfEnforceMandatoryProduct(services: any): boolean {
    for (const group of services) {
      const isSelectedControl = group.get('isSelected') as FormControl;
      const typeName = group.get('typeName').value;
      if (
        isSelectedControl.value &&
        typeName != "MandatoryForAllAdditionalServices"
      ) {
        return true;
      }
    }
    return false;
  }

  getSelectedServices(): FormGroup[] {
    return this._form.get('parking').get('additionalServices').controls.filter(
      (group: FormGroup) => group.get('isSelected')?.value === true
    ) as FormGroup[];
  }

  getSeletecedServicesRawValue(): Array<any> {
    const selectedServices = this.getSelectedServices();
    return selectedServices.map(group => group.value);
  }

  getMandatoryServices(): FormGroup[] {
    return this._form.get('parking').get('additionalServices').controls.filter((group: FormGroup) => {
      if (group.get('typeName')?.value == "MandatoryForAllAdditionalServices") {
        return true;
      }
      return false;
    }) as FormGroup[];
  }

  get additionalServices(): FormArray {
    return this._form.get('parking').get('additionalServices') as FormArray;
  }

  get organizationId() {
    return this._organizationId;
  }

  public set organizationId(value: any) {
    this._organizationId = value;
  }

  public set availableParkings(val: any) {
    this._availableParkings = val
  }

  public get availableParkings() {
    return this._availableParkings
  }

  public set selectedParking(val: any) {
    this._selectedParking = val
  }

  public get selectedParking() {
    return this._selectedParking;
  }

  public set selectedArrivalFlight(val: any) {
    this._selectedArrivalFlight = val
  }

  public get selectedArrivalFlight() {
    return this._selectedArrivalFlight
  }

  public updatedDepartureFlight$ = this._updatedDepartureFlight.asObservable();
  set updatedDepartureFlight(val: any) {
    this._updatedDepartureFlight.next(val);
  }

  public get updatedDepartureFlight() {
    return this._updatedDepartureFlight;
  }

  public isPaymentCompleted$ = this._isPaymentCompleted.asObservable();
  set isPaymentCompleted(val: any) {
    this._isPaymentCompleted.next(val);
  }

  public get isPaymentCompleted() {
    return this._isPaymentCompleted;
  }

  public toThePayment$ = this._toThePayment.asObservable();
  set toThePayment(val: any) {
    this._toThePayment.next(val);
  }

  public get toThePayment() {
    return this._toThePayment;
  }

  public seletedDepartureFlight$ = this._selectedDepartureFlight.asObservable();
  set selectedDepartureFlight(val: any) {
    this._selectedDepartureFlight.next(val);
  }

  public get selectedDepartureFlight() {
    return this._selectedDepartureFlight;
  }

  public daysBetweenDates(date1: Date, date2: Date) {
    const oneDay = 1000 * 60 * 60 * 24;
    const differenceInTime = date2.getTime() - date1.getTime();
    return Math.floor(differenceInTime / oneDay);
  }

  calculateParkingDays(startDate: Date, endDate: Date) {
    let days = this.daysBetweenDates(startDate, endDate);
    return days > 0 ? days : 1;
  }

  public set arrivalFlightList(val: any) {
    this._arrivalFlightList
  }
  public set departureFlightList(val: any) {
    this._departureFlightList
  }

  setFormValues(searchData: any) {
    if (!searchData) {
      return;
    }

    if (this.site == 'quality' || this.site == 'aiden') {
      const search = this._form.get('search');
      const hotels = this._form.get('hotels');
      const flights = this._form.get('flights');
      const pickup = this._form.get('pickup');
      const terminal = this._form.get('terminal');
      const parkingGroup = this._form.get('parkingGroup');

      hotels.patchValue({
        arrivalDate: searchData.arrivalDate,
        parkingEndDatetime: searchData.parkingEndDatetime,
        departureFlightDate: searchData.departureFlightDate,
        departureDatetime: searchData.departureDatetime,
        departureDatetimeForTransfer: searchData.departureDatetimeForTransfer,
        parkingStartDate: searchData.parkingStartDate
      })

      flights.patchValue({
        departureFlight: searchData.departureFlight,
        arrivalFlight: searchData.arrivalFlight
      });

      search.patchValue({
        isDepartureHotel: searchData.isDepartureHotel,
        isArrivalHotel: searchData.isArrivalHotel,
        isArrivalByFlight: searchData.isArrivalByFlight
      });

      if (pickup) {
        pickup.patchValue({
          departurePassengers: searchData.departurePassengers,
          departureRoute: searchData.departureRoute,
          arrivalRoute: searchData.arrivalRoute
        });
      }

      if (terminal) {
        terminal.patchValue({
          arrivalTerminal: searchData.arrivalTerminal,
          departureTerminal: searchData.departureTerminal
        });
      }

      if (parkingGroup) {
        parkingGroup.patchValue({
          departureDate: searchData.departureFlightDate,
          arrivalDate: searchData.arrivalDate,
          departureFlight: searchData.departureFlight,
          arrivalFlight: searchData.arrivalFlight
        });
      }

    } else {

      const hotels = this._form.get('hotels');
      const flights = this._form.get('flights');
      const search = this._form.get('search');

      hotels.patchValue({
        arrivalDatetime: searchData.hotelArrivalDate,
        departureDatetime: searchData.hotelDepartureDate,
        arrivalHotel: searchData.arrivalHotel,
        departureHotel: searchData.departureHotel
      });

      search.patchValue({
        arrivalFlightDate: searchData.arrivalFlightDate,
        departureFlightDate: searchData.departureFlightDate,
        departureDatetime: searchData.departureDatetime,
        arrivalDatetime: searchData.arrivalDatetime
      });

      flights.patchValue({
        departureFlight: searchData.departureFlight,
        arrivalFlight: searchData.arrivalFlight
      });
    }

  }

  getShuttleDate(flightDateStr: string, hasBaggage: any) {
    if (!flightDateStr) return '';
    const flightDate = new Date(flightDateStr);
    const minutesToAdd = hasBaggage ? 45 : 25;
    flightDate.setMinutes(flightDate.getMinutes() + minutesToAdd);
    return this.formatDate(flightDate);
  };

  createCustomerData() {
    let form = this._form.value;
    const isFromCustomerHome = !!(
      sessionStorage.getItem('isFromCustomerHome') === 'true' ||
      sessionStorage.getItem('selectedParkingFromSearch')
    );

    let customerData: Booking = {
      isFromCustomerHome: isFromCustomerHome,
      order: {
        organizationId: (this.site?.toLocaleLowerCase() == 'tui' || this.site?.toLocaleLowerCase() == 'nazar') ? this.config.targetOrgId : this.config.orgId,
        bundleCode: this._selectedParking.bundleCode,
        productCode: this._selectedParking.productCode,
        discountCode: this.discountCode,
        comment: form.details.comment,
        isFromCustomerHome: isFromCustomerHome
      },
      customer: {
        firstname: form.details.firstname,
        lastname: form.details.lastname,
        email: form.details.email,
        cellular: form.details.cellular
      },
      parking: {
        parkingId: this._selectedParking.id,
        productCode: this._selectedParking.productCode,
        carId: form.details.regNr,
        parkingFrom: this.formatDate(new Date(this.searchStartDate)),
        //subtract an hour, because one hour is added in backend. Works because we add an hour on the flight in frontend already.
        parkingTo: this.formatDate(subHours(new Date(this.searchEndDate), 1)),
        comment: form.details.comment,
        extendPeriod: 0,
        passengers: parseInt(form.details.persons),
        parkingCapacityMultiplier: this._selectedParking.parkingCapacityMultiplier
      },

    };

    const departureFlightnr = form.parkingGroup.departureFlight?.flightId ?? null;
    const departureFlightdate = form.parkingGroup.departureFlight?.departureTime?.scheduled
      ? new Date(form.parkingGroup.departureFlight?.departureTime.scheduled).toString().replace(/\s\(.*\)$/, "")
      : undefined;
    const departureFlightdeparturedate = form.parkingGroup.departureFlight?.flightLegIdentifier?.flightDepartureDateUtc ?? null;
    const departureFlightterminal = form.parkingGroup.departureFlight?.locationAndStatus?.terminal ?? null;

    const arrivalFlightnr = form.parkingGroup.arrivalFlight?.flightId ?? null;
    const arrivalFlightdate = form.parkingGroup.arrivalFlight?.arrivalTime?.scheduled
      ? new Date(form.parkingGroup.arrivalFlight.arrivalTime.scheduled).toString().replace(/\s\(.*\)$/, "")
      : undefined;
    const arrivalFlightdeparturedate = form.parkingGroup.arrivalFlight?.flightLegIdentifier?.flightDepartureDateUtc ?? null;
    const arrivalFlightterminal = form.parkingGroup.arrivalFlight?.locationAndStatus?.terminal ?? null;

    const arrivalHotel = this.arrivalHotel?.value || form.hotels?.arrivalHotel;
    const departureHotel = this.departureHotel?.value || form.hotels?.departureHotel;


    let departureTerminal = departureHotel || departureFlightterminal;
    let arrivalTerminal = arrivalHotel || arrivalFlightterminal;

    const config = this.bookingConfigService.getConfig();

    if (config.site === 'flygets' || config.site === 'nazar' || config.site === 'tui' || config.site === 'quality' || config.site === 'aiden') {
      customerData.shuttles = [
        {
          stationcode: 'ARN',
          shuttletypecode: config.site === 'quality' ? 'quality-hotel-xpo-arlanda-airport-transfer' : (config.site === 'aiden' ? 'aiden-airport-transfer-new' : 'flygets-p1-airport-transfer'),
          productcode: config.site === 'quality' ? 'QUALITYARLDEP' : 'SHUTDEP',
          shuttledate: this.formatDate(new Date(this.searchStartDate)),
          flightnr: departureFlightnr,
          flightdate: departureFlightdate,
          flightdeparturedate: departureFlightdeparturedate,
          flightterminal: departureFlightterminal,
          terminal: departureTerminal,
          passengers: form.details.persons,
          childseats: 0,
          baggage: form.details.onlyHandBaggage,
          comment: form.details.comment
        },
        {
          stationcode: 'ARN',
          shuttletypecode: config.site === 'quality' ? 'quality-hotel-xpo-arlanda-hotel-transfer' : (config.site === 'aiden' ? 'aiden-hotel-transfer-new' : 'flygets-p1-parking-transfer'),
          productcode: config.site === 'quality' ? 'QUALITYARLARR' : 'SHUTARR',
          shuttledate: arrivalFlightdate ? this.getShuttleDate(arrivalFlightdate, form.details.onlyHandBaggage) : this.formatDate(new Date(this.searchEndDate)),
          flightnr: arrivalFlightnr,
          flightdate: arrivalFlightdate,
          flightdeparturedate: arrivalFlightdeparturedate,
          flightterminal: arrivalFlightterminal,
          terminal: arrivalTerminal,
          passengers: form.details.persons,
          childseats: 0,
          baggage: form.details.onlyHandBaggage,
          comment: form.details.comment
        }
      ]
    }
    else if (config.site === 'mdpark') {
      customerData.shuttles = [
        {
          stationcode: 'ARN',
          shuttletypecode: 'mdpark-airport-transfer',
          productcode: 'MDPARKARLDEP',
          shuttledate: this.formatDate(new Date(this.searchStartDate)),
          flightnr: departureFlightnr,
          flightdate: departureFlightdate,
          flightdeparturedate: departureFlightdeparturedate,
          flightterminal: departureFlightterminal,
          terminal: departureTerminal,
          passengers: form.details.persons,
          childseats: 0,
          baggage: form.details.onlyHandBaggage,
          comment: form.details.comment
        },
        {
          stationcode: 'ARN',
          shuttletypecode: 'mdpark-parking-transfer',
          productcode: 'MDPARKARLARR',
          shuttledate: arrivalFlightdate ? this.getShuttleDate(arrivalFlightdate, form.details.onlyHandBaggage) : this.formatDate(new Date(this.searchEndDate)),
          flightnr: arrivalFlightnr,
          flightdate: arrivalFlightdate,
          flightdeparturedate: arrivalFlightdeparturedate,
          flightterminal: arrivalFlightterminal,
          terminal: arrivalTerminal,
          passengers: form.details.persons,
          childseats: 0,
          baggage: form.details.onlyHandBaggage,
          comment: form.details.comment
        }
      ]
    }
    else if (config.site === 'quality-xpo-arlanda' && form.details.bookingNumber) {
      customerData.order.externalBookingReference = form.details.bookingNumber;
    }

    if (config.site === 'quality' || config.site === 'aiden') {
      if (form.details.bookingNumber) {
        customerData.order.externalBookingReference = form.details.bookingNumber;
      }
      customerData.order.shuttleOrganizationId = this.config.shuttleOrgId;

      customerData.shuttles[0].passengers = form.pickup?.departurePassengers;
      customerData.shuttles[1].passengers = form.pickup?.departurePassengers;
      customerData.parking.passengers = form.pickup?.departurePassengers;

      if (!(form.search.isArrivalByFlight)) {
        const arrTerminal = form.terminal.arrivalTerminal;
        customerData.shuttles[1].flightnr = null;
        customerData.shuttles[1].flightdate = null;
        customerData.shuttles[1].flightdeparturedate = null;
        customerData.shuttles[1].flightterminal = null;
        customerData.shuttles[1].terminal = arrTerminal?.terminalCode || '';
      }

      if (form.search.isDepartureHotel) {
        const depTerminal = form.terminal.departureTerminal;
        customerData.shuttles[0].terminal = depTerminal?.terminalCode || '';
      }

      const depRoute = form.pickup.departureRoute;
      const arrRoute = form.pickup.arrivalRoute;
      customerData.shuttles[0].shuttledate = moment(depRoute?.startDate)?.format('YYYY-MM-DDTHH:mm:ss') || '';
      customerData.shuttles[0].ordershuttlebusid = depRoute?.orderShuttleBusId || '';
      customerData.shuttles[1].shuttledate = moment(arrRoute?.startDate)?.format('YYYY-MM-DDTHH:mm:ss') || '';
      customerData.shuttles[1].ordershuttlebusid = arrRoute?.orderShuttleBusId || '';
    }

    if (this.additionalServices) {
      customerData.additionalServices = this.getSeletecedServicesRawValue();
    }

    const isParkingPermitUser = sessionStorage.getItem('isParkingPermitUser') === 'true';
    if (isParkingPermitUser) {
      customerData.order.organizationId = '4FF1E3D8-950F-4E11-AB60-0F0769FF23A2';
    }

    return customerData;
  }

  formatDate(sourceDate: Date): string {
    var twoDigitMonth = ((sourceDate.getMonth() + 1) >= 10) ? (sourceDate.getMonth() + 1) : '0' + (sourceDate.getMonth() + 1);
    var twoDigitDate = ((sourceDate.getDate()) >= 10) ? (sourceDate.getDate()) : '0' + (sourceDate.getDate());
    var twoDigitHour = ((sourceDate.getHours()) >= 10) ? (sourceDate.getHours()) : '0' + (sourceDate.getHours());
    var twoDigitMinute = ((sourceDate.getMinutes()) >= 10) ? (sourceDate.getMinutes()) : '0' + (sourceDate.getMinutes());
    var returnDate = sourceDate.getFullYear() + "-" + twoDigitMonth + "-" + twoDigitDate + 'T' + twoDigitHour + ':' + twoDigitMinute + ':00';
    return returnDate;
  }

  getDailyPrice() {
    let daysBetween = this.daysBetweenDates(
      this._form.get('parkingGroup').controls['departureDate'].value,
      this._form.get('parkingGroup').controls['arrivalDate'].value
    )

    return this.selectedParking.totalPrice / (daysBetween === 0 ? 1 : daysBetween)
  }
}
